import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import MessageBox from './components/base/MessageBox'
import { WS_CONNECT, WS_DISCONNECT } from './middlewares/socketMiddleware'

const WebSocketUI = () => {
  const dispatch = useDispatch()
  const userError = useSelector(state => state.user.error)
  const showAuthTokenMessage = useSelector(state => state.mainView.showAuthTokenMessage)

  useEffect(() => {
    dispatch({ type: WS_CONNECT })
    return () => {
      dispatch({ type: WS_DISCONNECT })
    }
  }, [ dispatch ])

  return (
    <>
      <If condition={showAuthTokenMessage}>
        <MessageBox
          message={__CFG__.CUSTOM.AUTH_TOKEN_MISSED_MESSAGE}
          onClose={() => { window.open(__CFG__.CUSTOM.BACKURL, '_top') }}
        />
      </If>
      <If condition={userError}>
        <MessageBox
          title={userError.title}
          message={userError.message}
          onClose={() => { window.location.reload() }}
        />
      </If>
    </>
  )
}

export default WebSocketUI
